module.exports = __webpack_public_path__ + "media/images/pic/saska/team/teachers/sonja-gorniak-f2610022a6ff51fcc33cebdf56c4d56c.webp";